import HttpClient from '@src/shared/services/base/http-client';
import MCPMarketEnvironmentDetection, {
  MCP_MARKET_ENVIRONMENT_COUNTRY_CODES,
} from '@src/shared/utils/market-environment-detection';

class DeliveryDataService extends HttpClient {
  constructor(baseURL: string, authHeaderName: string) {
    super(baseURL, authHeaderName);
  }

  public getDeliveryData: any = (restuarantId: string) => {
    return this.instance.get(`/${restuarantId}/statistics`);
  };
}

const getBaseUrl = () => {
  const { countryCode } = MCPMarketEnvironmentDetection.getMarketEnvironment();
  if (countryCode === MCP_MARKET_ENVIRONMENT_COUNTRY_CODES.UK) {
    return process.env.RESTAURANT_SETTINGS_API_NEW_URL_EU_WEST as string;
  }
  return process.env.RESTAURANT_SETTINGS_API_NEW_URL_EU_CENTRAL as string;
};

export default new DeliveryDataService(getBaseUrl(), 'X-Auth');
